import React from "react";
import UpdatesBanner from "../UpdatesBanner/UpdatesBanner";
import SolutionEcosystem from "../WebSite/SolutionEcosystem/SolutionEcosystem";
import { Container } from "@material-ui/core";

import OnMarketplaceFeatures from "./OnMarketplaceFeatures";
import OverviewFeatures from "../OverviewFeatures/OverviewFeatures";
import OnMarketPlaceAPPBenefits from "./OnMarketPlaceAPPBenefits";

// Main component for AgriOutputMarketplace
export default function OnMarketPlaceAPP() {
  // Overview data
  const data1 = [
    "Buy and Sell Service: AgriOutputMarketPlace facilitates the buying and selling of raw, semi-processed and processed fostering efficient trade in agricultural commodities.",
  ];

  return (
    <>
      {/* Banner Section */}
      <UpdatesBanner
        className="agriinput-marketplace-bg"
        bannerTitle={["AgriOutputMarketPlace"]}
        bannerbodycopy="BulkonMarketplace | onMarketplace"
      />

      {/*  Overview  Section*/}
      <SolutionEcosystem title="Overview" type="ONM" />

      {/*  Overview Feature */}
      <Container>
        <OverviewFeatures data1={data1} />
      </Container>

      {/*  Features & Benefits Section */}
      <OnMarketplaceFeatures />
      <OnMarketPlaceAPPBenefits />
    </>
  );
}
